import { Employee } from '..'

import { CustomerContact } from './contact'
import { CustomerAssignment } from './assignment'
import { CustomerEmployee } from './employee'

export * from './contact'
export * from './assignment'
export * from './employee'

export class CreateCustomerVariables {
  name: string
  description?: string
  business_identity_code: string
  assignments: CustomerAssignment[]
  contacts: CustomerContact[]
  tes_name?: string
  employees: CustomerEmployee[]
  city?: string

  constructor(customer: CreateCustomerVariables) {
    const errors = []

    if (!customer.name) {
      errors.push({ name: 'string' })
    }

    if (!customer.contacts || !Array.isArray(customer.contacts)) {
      errors.push({ contacts: 'array' })
    }

    if (!customer.assignments || !Array.isArray(customer.assignments)) {
      errors.push({ assignments: 'array' })
    }

    if (!customer.employees || !Array.isArray(customer.employees)) {
      errors.push({ employees: 'array' })
    }

    if (errors.length > 0) {
      throw JSON.stringify(errors)
    }

    this.name = customer.name
    this.description = customer.description
    this.business_identity_code = customer.business_identity_code
    this.contacts = customer.contacts.length > 0 ? customer.contacts.map((item) => new CustomerContact(item)) : []
    this.tes_name = customer.tes_name
    this.assignments =
      customer.assignments.length > 0 ? customer.assignments.map((item) => new CustomerAssignment(item)) : []
    this.employees = customer.employees
    this.city = customer.city
  }
}

export class Customer extends CreateCustomerVariables {
  _id: string
  _employees?: Employee[]

  constructor(customer: Customer) {
    super(customer)

    if (!customer._id) {
      throw '_id'
    }

    this._id = customer._id
  }
}
